(ns common.schema.entities.permissions
  (:require [common.roles :as roles]))

(defn disable-when-no-write-permission
  [{:keys [tr role entity has-write-permissions?]}]
  (when-not (or (roles/admin? role)
                (has-write-permissions? entity))
    (tr :not-allowed)))
